import Navbar from '../components/Navbar';
import './pages.css';
import '../components/contacto.css';
import { useState } from 'react';

function Contacto() {

  const [form, setForm] = useState({
    nombre: '',
    telefono: '',
    correo: '',
    mensaje: ''
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async () => {

    if (!form.nombre || !form.telefono || !form.correo || !form.mensaje) {
      alert('Por favor completa todos los campos');
      return;
    }

    try {
      setLoading(true);

      const API_URL =
        window.location.hostname === 'localhost'
        ? 'https://copac.com.co/api/contacto.php'
        : '/api/contacto.php';              

      const res = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(form)
      });

      if (!res.ok) {
        console.error('Error HTTP:', res.status);
        alert('Error del servidor');
        return;
      }

      const text = await res.text();

      let data;

      try {
        data = JSON.parse(text);
      } catch (e) {
        console.error('Respuesta no es JSON:', text);
        alert('Error en el servidor');
        return;
      }

      if (data.ok) {
        alert('✅ Mensaje enviado correctamente');

        setForm({
          nombre: '',
          telefono: '',
          correo: '',
          mensaje: ''
        });

      } else {
        alert(data.message || 'Error al enviar');
      }

    } catch (err) {
      console.error(err);
      alert('Error de conexión con el servidor');
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Navbar />

      <div className="page">

        <div className="contacto-container">

          {/* MAPA */}
          <div className="contacto-mapa">
            <iframe
              src="https://www.google.com/maps?q=Compañía+Papelera+de+Colombia+La+Virginia&output=embed"
              title="Ubicación"
            />
          </div>

          <div className="contacto-panel">

            {/* INFO */}
            <div className="contacto-info">
              <h3>📞 LLÁMENOS</h3>
              <p>CEL: (302) 466 0543</p>

              <h3>📍 UBICACIÓN</h3>
              <p>
                Kilometro 8 via Cerritos la Virginia
                Sector La Lorena Lote 9 - Pereira (Risaralda)
              </p>
            </div>

            {/* FORMULARIO */}
            <div className="contacto-form">
              <h3>CONTÁCTENOS</h3>

              <input
                type="text"
                name="nombre"
                placeholder="Escribe tu nombre"
                value={form.nombre}
                onChange={handleChange}
              />

              <input
                type="text"
                name="telefono"
                placeholder="Teléfono"
                value={form.telefono}
                onChange={handleChange}
              />

              <input
                type="email"
                name="correo"
                placeholder="Correo electrónico"
                value={form.correo}
                onChange={handleChange}
              />

              <textarea
                name="mensaje"
                placeholder="Descripción..."
                value={form.mensaje}
                onChange={handleChange}
              ></textarea>

              <button onClick={handleSubmit} disabled={loading}>
                {loading ? 'Enviando...' : 'Enviar'}
              </button>

            </div>

          </div>
        </div>

      </div>
    </>
  );
}

export default Contacto;